// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"22ec8ec2","488":"8d105082","594":"2a6aa0d2"}[chunkId] + ".chunk.js";
};